import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Select, InputNumber, Space } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";
import { getRequest } from "services/EndPointApiService";
import LionParcelResi from "./LionParcelResi";

export default function PrintResiBC() {
  const componentRef = useRef();
  const [paperSize, setPaperSize] = useState("custom");
  const [customSize, setCustomSize] = useState({ width: 120, height: 165 });

  const [dataResi, setDataResi] = useState([]);

  const printDialog = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "OSD Printer",
  });

  useEffect(() => {
    getRequest("LionParcel/GetPrintResiData").then((data) => {
      if (data && data.length > 0) {
        setDataResi(data);
      }
    });
  }, []);

  return (
    <div>
      <Card>
        <div>
          <h1>📦 Print Resi BC</h1>

          <Space>
            <Select
              value={paperSize}
              onChange={setPaperSize}
              style={{ width: 160 }}
              options={[
                { value: "a4", label: "A4 (210 × 297 mm)" },
                { value: "t110mm", label: "Thermal 110mm" },
                { value: "t80mm", label: "Thermal 80mm" },
                { value: "t58mm", label: "Thermal 58mm" },
                { value: "custom", label: "Custom Size" },
              ]}
            />

            {paperSize === "custom" && (
              <Space>
                <InputNumber
                  min={30}
                  max={300}
                  value={customSize.width}
                  onChange={(val) =>
                    setCustomSize((prev) => ({ ...prev, width: val || 0 }))
                  }
                  addonAfter="mm"
                  style={{ width: 110 }}
                />
                <InputNumber
                  min={30}
                  max={500}
                  value={customSize.height}
                  onChange={(val) =>
                    setCustomSize((prev) => ({ ...prev, height: val || 0 }))
                  }
                  addonAfter="mm"
                  style={{ width: 110 }}
                />
              </Space>
            )}

            <Button type="primary" onClick={printDialog}>
              <Space>
                <PrinterOutlined />
                Print
              </Space>
            </Button>
          </Space>
        </div>

        {/* Area yang akan diprint + preview */}
        <div
          ref={componentRef}
          className={`print-container preview ${paperSize}`}
          style={
            paperSize === "custom"
              ? {
                  width: `${customSize.width}mm`,
                  minHeight: `${customSize.height}mm`,
                }
              : {}
          }
        >
          {dataResi.map((resi) => (
            <LionParcelResi key={resi.NoResi} data={resi} />
          ))}
        </div>
      </Card>

      {/* CSS preview & print */}
      <style>{`
        .print-container.preview {
          background: white;
          margin: 0 auto;
          box-shadow: 0 0 8px rgba(0,0,0,0.2);
        }

        .print-container.preview.a4 {
          width: 210mm;
          min-height: 297mm;
        }

        .print-container.preview.t110mm {
          width: 110mm;
          min-height: 150mm;
        }

        .print-container.preview.t80mm {
          width: 80mm;
          min-height: 120mm;
        }

        .print-container.preview.t58mm {
          width: 58mm;
          min-height: 120mm;
        }

        @media print {
          body {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          .print-container.a4 {
            width: 210mm;
            min-height: 297mm;
          }

          .print-container.t110mm {
            width: 110mm;
          }

          .print-container.t80mm {
            width: 80mm;
          }

          .print-container.t58mm {
            width: 58mm;
          }

          /* Custom akan ikut style inline (width/height) */
          .print-label {
            page-break-inside: avoid;
            border: 1px solid #000;
          }

          .print-container.preview {
            box-shadow: none;
            margin: 0;
          }
        }
      `}</style>
    </div>
  );
}
